module.exports = __webpack_public_path__ + "img/illinoisvehicle-logo.ae403108.svg";